export default "__VITE_ASSET__BYbVCwRC__"